// src/app/auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { ConfigService } from './config.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';
import { EncryptionService } from '../encryption.service';

@Injectable({
  providedIn: 'root',
})

export class AuthService {
  // Replace with your API URL
  private _authToken: string | null = localStorage.getItem('authToken');


  private _isAuthenticated = new BehaviorSubject<boolean>(this.hasToken());

  public currentUserSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  ); // Initialize with null
  public currentUser: Observable<any> = this.currentUserSubject.asObservable();



  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private router: Router,
    private EncryptionService: EncryptionService

  ) {
    const currentUser: any = localStorage.getItem('currentUser');
    if (currentUser) {
      let data = JSON.parse(currentUser);
      let a = this.EncryptionService.decrypt(data.cipherText, data.iv);
      this.currentUserSubject.next(JSON.parse(a));
      // this.currentUserSubject.next(JSON.parse(currentUser));

    }
    const token = localStorage.getItem('authToken');
    if (token && this.isTokenExpired(token)) {
      this.performClientLogout();
    }
  }
  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }
storeUser(user: any) {
  localStorage.setItem('token', user.token);

  const encrypted = this.EncryptionService.encrypt(JSON.stringify(user));
  localStorage.setItem('currentUser', JSON.stringify(encrypted));
}


  


  // Login method
  login(postData: any): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Authentication/SignIn`;
    return this.http.post<any>(apiUrl, postData).pipe(
      tap((response) => {
        if (response.status === 200) {
          this._authToken = response.data.authToken;
          localStorage.setItem('authToken', this._authToken!);

          let a: any = this.EncryptionService.encrypt(JSON.stringify(response.data))
          localStorage.setItem('currentUser', JSON.stringify(a));
          this.currentUserSubject.next(response.data);

          this._isAuthenticated.next(true);
        }
        return response;
      }),
      // catchError((err) => {
      //   console.error('API Error: ', err);
      //   return throwError(() => new Error('Login failed.'));
      // })
      catchError(err => throwError(() => err))

    );
  }

  // Logout method
  // logout(): void {
  //   this._authToken = null;
  //   localStorage.removeItem('authToken');
  //   localStorage.removeItem('currentUser');
  //   sessionStorage.clear();
  //   this.currentUserSubject.next(null);
  //   this._isAuthenticated.next(false);
  //   this.router.navigate(['/home']);
  //   localStorage.clear();
  // }

  logoutChangeRole(): void {
    const token = localStorage.getItem('authToken');
    if (!token) {
      this.performClientLogout();
      return;
    }

    const apiUrl = `${this.configService.getApiUrl()}/Authentication/logout`;
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' });

    this.http.post(apiUrl, {}, { headers }).subscribe({
      next: () => {},
      error: () => this.performClientLogout(),
    });
  }
  logout(): void {
    const token = localStorage.getItem('authToken');
    if (!token) {
      this.performClientLogout();
      return;
    }

    const apiUrl = `${this.configService.getApiUrl()}/Authentication/logout`;
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' });

    this.http.post(apiUrl, {}, { headers }).subscribe({
      next: () => this.performClientLogout(),
      error: () => this.performClientLogout(),
    });
  }

  public performClientLogout(): void {
    this._authToken = null;

    localStorage.removeItem('authToken');
    localStorage.removeItem('currentUser');

    sessionStorage.clear();
    localStorage.clear();
    this.currentUserSubject.next(null);
    this._isAuthenticated.next(false);
    this.router.navigate(['/home']);
  }
 


  // Check if the user is authenticated
  isAuthenticated(): boolean {
    return !!this.currentUserValue;
  }
  isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const now = Math.floor(Date.now() / 1000);
      return now >= payload.exp;
    } catch {
      return true;
    }
  }
  get authToken(): string | null {
    return this._authToken;
  }



  //ChangePassword
  ChangePassword(postData: any): Observable<any> {
    const apiUrl = `${this.configService.getApiUrl()}/Authentication/ChangePassword`;
    return this.http.post<any>(apiUrl, postData).pipe(
      tap((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Change password failed.'));
      })
    );
  }
  //Forgot password
  varifyUserMobile(userID: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Authentication/VerifyUserMobile?userID=${userID}`;
    return this.http.get<any>(apiUrl).pipe(
      tap((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(
          () => new Error('Mobile number verification failed.')
        );
      })
    );
  }
  // Check if a token exists in localStorage
  private hasToken(): boolean {
    return !!this._authToken;
  }
  private hasTokenInLocalStorage(): boolean {
    return !!localStorage.getItem('authToken');
  }
  // isTokenExpired(): boolean {
  //   const token = localStorage.getItem('authToken');
  //   if (!token) return true;

  //   try {
  //     const payload = JSON.parse(atob(token.split('.')[1]));
  //     const exp = payload.exp;
  //     const now = Math.floor(Date.now() / 1000); // Current time in seconds
  //     return now >= exp;
  //   } catch (error) {
  //     console.error('Token decode error', error);
  //     return true;
  //   }
  // }
}
